import React from 'react';
import moment from 'moment-timezone';
import { trainKindClass } from '../../data/trainKinds';
import { estimatedTime } from '../../services/trainsService';

const TrainSchedule = ({ schedules, train, isSuspended }) => {
  // 始発駅にいる列車の判定
  const isAtOriginStation = checkAtOriginStation(train, schedules);

  // 始発駅にいる列車は始発駅の行を表示しない
  // 始発駅はarrivalTimeがなく、departureTimeのみある
  const dispalySchedules = isAtOriginStation ? schedules.slice(1) : schedules;
  
  return (
    <ul className="train-schedule-list">
      {dispalySchedules && dispalySchedules.map((schedule, index) => {
        const last = isLastStation(dispalySchedules, index);
        const through = !last && schedule.departureTime === undefined;
        const delayed = !isSuspended && train.delay > 59 && !isAtOriginStation;
        const timeClass = isSuspended ? 'long-delay' : (delayed ? 'delayed' : '');

        return (
          <li
            key={index}
            className={`train-schedule-row ${through ? 'through' : ''}`}
          >
            <div className={`station-line ${trainKindClass(train.train_kind_id)} ${last ? 'last-station' : ''}`}></div>
            <div className="station-info">
              <p className="station-name">{schedule.stationName}</p>
              <p className={`station-scheduled-time ${timeClass}`}>
                {scheduledTimeText(schedule, through, isSuspended)}
              </p>
              <p className={`station-estimated-time ${timeClass}`}>
                {estimatedTimeText(schedule, through, isSuspended, train.delay, isAtOriginStation)}
              </p>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

const checkAtOriginStation = (train, schedules) => {
  const firstSchedule = schedules && schedules[0];
  if (!checkOriginStation(firstSchedule)) {
    return false
  };

  return train.next_station_id === null && firstSchedule.stationId === train.station_id;
}

const checkOriginStation = (firstSchedule) => {
  return firstSchedule && firstSchedule.arrivalTime === undefined && firstSchedule.departureTime !== undefined;
}

const isLastStation = (schedules, index) => schedules.length === index + 1;

const scheduledTimeText = (schedule, through, isSuspended) => {
  // 通過駅は見合わせ中でも常に「通過」と表示する
  if (through) {
    return '通過';
  }

  if (isSuspended) {
    return '-';
  }

  return moment(schedule.arrivalTime, 'HH:mm').format('H:mm');
};

const estimatedTimeText = (schedule, through, isSuspended, delaySeconds, isAtOriginStation) => {
  // 運転見合わせの場合は従来の通り `-` を表示する
  if (isSuspended) {
    return '-';
  }

  // 始発駅にいる列車は、遅延情報があっても次駅以降を定刻で表示（見込み時刻を表示しない）
  if (isAtOriginStation) {
    return '-';
  }

  // 通過駅の見込みは、遅延している場合のみ「通過」、遅延なしなら「-」
  if (through) {
    return delaySeconds > 59 ? '通過' : '-';
  }

  return estimatedTime(schedule.arrivalTime, delaySeconds) || '-';
};

export default TrainSchedule;
